import { useTranslation } from "react-i18next";
import { getColor } from "../../../../pages/postEditor/seoAnalyzer/helper";

export const ContentAnalysis = ({ analysis }) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Score Bar */}
       <div className="mt-4">
                  <span className="font-semibold mb-3">
                    {analysis.total_score}%
                    </span>
                    </div>
                  
                  <div className="w-full relative p-2 rounded-xl bg-slate-300 mb-5 mt-1">
                    <div
                      className={`bg-${getColor(
                        analysis.total_score
                      )} h-full rounded-xl absolute top-0 left-0`}
                      style={{ width: `${analysis.total_score}%` }}
                    ></div>
                  </div>

      {/* Character and Word Count */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Total-Word-&-Character-Count", "Total Word & Character Count ")}{" "}
        </p>
        <p
          className={`${
            analysis?.word_count?.score == 100
              ? "text-green-500"
              : analysis?.word_count?.score === 70
              ? "text-yellow-400"
              : analysis?.word_count?.score == 35
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.word_count?.score == 100 && (
            <>
              {`${t(
                "The-content-has-a-good-length (",
                "The content has a good length ("
              )}${analysis?.word_count.words} ${t("word", "word")}${
                analysis?.word_count.words > 0 ? "s" : ""
              } ) ${t("That's-perfect!", " That's-perfect!")}`}
            </>
          )}

          {analysis?.word_count?.score == 70 && (
            <>
              {`${t("The-content-is-a-bit", "The content is a bit")} ${
                analysis?.word_count.percentage > 110 &&
                analysis?.word_count.percentage <= 120
                  ? t("long", "long")
                  : analysis?.word_count.percentage >= 80 &&
                    analysis?.word_count.percentage < 90
                  ? t("short", "short")
                  : ""
              } 
              ${
                analysis?.word_count.competitors
                  ? t(
                      "compared-to-the-competitors",
                      "compared to the competitors"
                    )
                  : t("compared-to-the-target", "compared to the target")
              } (${analysis?.word_count.words} ${t("word", "word")}${
                analysis?.word_count.words > 0 ? "s" : ""
              }  ${
                analysis?.word_count.words > analysis?.word_count.nb_words
                  ? ">"
                  : "<"
              } ${analysis?.word_count.nb_words}).`}
            </>
          )}
          {analysis?.word_count?.score == 35 && (
            <>
              {`${t("The-content-is-too", "The content is too")} ${
                analysis?.word_count.percentage > 120
                  ? t("long", "long")
                  : analysis?.word_count.percentage < 80
                  ? t("short", "short")
                  : ""
              } 
              ${
                analysis?.word_count.competitors
                  ? t(
                      "compared-to-the-competitors",
                      "compared to the competitors"
                    )
                  : t("compared-to-the-target", "compared to the target")
              } (${analysis?.word_count.words} ${t("word", "word")}${
                analysis?.word_count.words > 0 ? "s" : ""
              }  ${
                analysis?.word_count.words > analysis?.word_count.nb_words
                  ? ">"
                  : "<"
              } ${analysis?.word_count.nb_words}).`}
            </>
          )}
          {analysis?.word_count?.score == -1 && (
            <>{t("Please-add-content", "Please add content")}</>
          )}
        </p>
      </div>

      {/* Content Architecture */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Content-architecture", "Content architecture")}
        </p>
        {analysis?.content_architecture?.score === 100 ? (
          <p className="text-green-500 text-sm font-semibold">
            {t(
              "The-content-has-an-average-repartition-of-tags.Try-to-fix-it!",
              "The content has an average repartition of tags. Try to fix it!"
            )}
          </p>
        ) : analysis?.content_architecture?.score === 50 ? (
          <p className="text-yellow-400 text-sm font-semibold">
            {t(
              "The-content-has-an-average-repartition-of-tags.Try-to-fix-it!",
              "The content has an average repartition of tags. Try to fix it!"
            )}
          </p>
        ) : analysis?.content_architecture?.score === 0 ? (
          <p className="text-red-600 text-sm font-semibold">
            {t(
              "The-content-has-wrong-repartition-of-tags",
              "The content has a wrong repartition of tags."
            )}
          </p>
        ) : analysis?.content_architecture?.score === -1 ? (
          <p className="text-gray_local-400 text-sm font-semibold">
            {t("Please-add-content", "Please add content")}
          </p>
        ) : null}
        {analysis?.content_architecture?.score > -1 && (
          <ul className="text-sm font-semibold">
            <li
              className={
                analysis?.content_architecture.text_percentage >= 40 &&
                analysis?.content_architecture.text_percentage <= 70
                  ? "text-green-500"
                  : (analysis?.content_architecture.text_percentage >= 35 &&
                      analysis?.content_architecture.text_percentage < 40) ||
                    (analysis?.content_architecture.text_percentage > 70 &&
                      analysis?.content_architecture.text_percentage <= 75)
                  ? "text-yellow-400"
                  : "text-red-600"
              }
            >
              {analysis?.content_architecture.text_percentage >= 40 &&
              analysis?.content_architecture.text_percentage <= 70
                ? `- ${t("text", "text")}: ${
                    analysis?.content_architecture.text_percentage
                  }%`
                : (analysis?.content_architecture.text_percentage >= 35 &&
                    analysis?.content_architecture.text_percentage < 40) ||
                  (analysis?.content_architecture.text_percentage > 70 &&
                    analysis?.content_architecture.text_percentage <= 75)
                ? `- ${t("text", "text")}: ${
                    analysis?.content_architecture.text_percentage
                  }% ${
                    analysis?.content_architecture.text_percentage > 40
                      ? ">"
                      : "<"
                  } 40%`
                : `- ${t("text", "text")}: ${
                    analysis?.content_architecture.text_percentage
                  }% ${
                    analysis?.content_architecture.text_percentage > 75
                      ? ">"
                      : "<"
                  } 75% `}
            </li>
            <li
              className={
                analysis?.content_architecture.listings_percentage >= 10 &&
                analysis?.content_architecture.listings_percentage <= 25
                  ? "text-green-500"
                  : (analysis?.content_architecture.listings_percentage >= 8 &&
                      analysis?.content_architecture.listings_percentage <
                        10) ||
                    (analysis?.content_architecture.listings_percentage > 25 &&
                      analysis?.content_architecture.listings_percentage <= 27)
                  ? "text-yellow-400"
                  : "text-red-600"
              }
            >
              {analysis?.content_architecture.listings_percentage >= 10 &&
              analysis?.content_architecture.listings_percentage <= 25
                ? `- ${t("lists", "lists")}: ${
                    analysis?.content_architecture.listings_percentage
                  }%`
                : (analysis?.content_architecture.listings_percentage >= 8 &&
                    analysis?.content_architecture.listings_percentage < 10) ||
                  (analysis?.content_architecture.listings_percentage > 25 &&
                    analysis?.content_architecture.listings_percentage <= 27)
                ? `- ${t("lists", "lists")}: ${
                    analysis?.content_architecture.listings_percentage
                  }% ${
                    analysis?.content_architecture.listings_percentage > 10
                      ? ">"
                      : "<"
                  } 10% `
                : `- ${t("lists", "lists")}: ${
                    analysis?.content_architecture.listings_percentage
                  }% ${
                    analysis?.content_architecture.listings_percentage > 27
                      ? ">"
                      : "<"
                  } 27% `}
            </li>
            <li
              className={
                analysis?.content_architecture.tables_percentage >= 0 &&
                analysis?.content_architecture.tables_percentage <= 8
                  ? "text-green-500"
                  : analysis?.content_architecture.tables_percentage >= 9.5 &&
                    analysis?.content_architecture.tables_percentage < 11
                  ? "text-yellow-400"
                  : "text-red-600"
              }
            >
              {analysis?.content_architecture.tables_percentage >= 0 &&
              analysis?.content_architecture.tables_percentage <= 8
                ? `- ${t("tables", "tables")}: ${
                    analysis?.content_architecture.tables_percentage
                  }%`
                : analysis?.content_architecture.tables_percentage >= 9.5 &&
                  analysis?.content_architecture.tables_percentage < 11
                ? `- ${t("tables", "tables")}: ${
                    analysis?.content_architecture.tables_percentage
                  }% ${
                    analysis?.content_architecture.tables_percentage > 9.5
                      ? ">"
                      : "<"
                  } 9.5% `
                : `- ${t("tables", "tables")}: ${
                    analysis?.content_architecture.tables_percentage
                  }% ${
                    analysis?.content_architecture.tables_percentage > 11
                      ? ">"
                      : "<"
                  } 11%} `}
            </li>
            <li
              className={
                analysis?.content_architecture.quotes_percentage >= 0 &&
                analysis?.content_architecture.quotes_percentage <= 5
                  ? "text-green-500"
                  : analysis?.content_architecture.quotes_percentage >= 6 &&
                    analysis?.content_architecture.quotes_percentage < 7
                  ? "text-yellow-400"
                  : "text-red-600"
              }
            >
              {analysis?.content_architecture.quotes_percentage >= 0 &&
              analysis?.content_architecture.quotes_percentage <= 5
                ? `- ${t("quotes", "quotes")}: ${
                    analysis?.content_architecture.quotes_percentage
                  }%`
                : analysis?.content_architecture.quotes_percentage >= 6 &&
                  analysis?.content_architecture.quotes_percentage < 7
                ? `- ${t("quotes", "quotes")}: ${
                    analysis?.content_architecture.quotes_percentage
                  }% ${
                    analysis?.content_architecture.quotes_percentage > 6
                      ? ">"
                      : "<"
                  } 6% `
                : `- ${t("quotes", "quotes")}: ${
                    analysis?.content_architecture.quotes_percentage
                  }% ${
                    analysis?.content_architecture.quotes_percentage > 7
                      ? ">"
                      : "<"
                  } 7% `}
            </li>
            <li
              className={
                analysis?.content_architecture.emphasis_percentage >= 0.5 &&
                analysis?.content_architecture.emphasis_percentage <= 2
                  ? "text-green-500"
                  : (analysis?.content_architecture.emphasis_percentage >=
                      0.25 &&
                      analysis?.content_architecture.emphasis_percentage < 2) ||
                    (analysis?.content_architecture.emphasis_percentage > 2 &&
                      analysis?.content_architecture.emphasis_percentage < 2.25)
                  ? "text-yellow-400"
                  : "text-red-600"
              }
            >
              {analysis?.content_architecture.emphasis_percentage >= 0.5 &&
              analysis?.content_architecture.emphasis_percentage <= 2
                ? `- ${t("emphasis", "emphasis")}: ${
                    analysis?.content_architecture.emphasis_percentage
                  }%`
                : (analysis?.content_architecture.emphasis_percentage >= 0.25 &&
                    analysis?.content_architecture.emphasis_percentage < 0.5) ||
                  (analysis?.content_architecture.emphasis_percentage > 2 &&
                    analysis?.content_architecture.emphasis_percentage <= 2.25)
                ? `- ${t("emphasis", "emphasis")}: ${
                    analysis?.content_architecture.emphasis_percentage
                  }% ${
                    analysis?.content_architecture.emphasis_percentage > 2
                      ? "> 2%"
                      : "< 0.5%"
                  }`
                : `- ${t("emphasis", "emphasis")}: ${
                    analysis?.content_architecture.emphasis_percentage
                  }% ${
                    analysis?.content_architecture.emphasis_percentage > 2.25
                      ? "> 2.25%"
                      : "< 0.25%"
                  }`}
            </li>
          </ul>
        )}
      </div>

      {/* Target Request */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Target-Request", "Target Request")}{" "}
        </p>
        <p
          className={`${
            analysis?.target_request?.score == 100
              ? "text-green-500"
              : analysis?.target_request?.score === 50
              ? "text-yellow-400"
              : analysis?.target_request?.score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.target_request?.score == 100 && (
            <>
              {t(
                "The-target-request-appears-in-your-150-first-words.That’s-perfect!",
                "The target request appears in your 150 first words. That’s perfect!"
              )}
            </>
          )}
          {analysis?.target_request?.score == 50 && (
            <>
              {t(
                "The-target-request-partially-appears-in-the-150-first-words-of-your-content!-Adding-it-entirely-would-be-ideal!",
                "The target request partially appears in the 150 first words of your content! Adding it entirely would be ideal!"
              )}
            </>
          )}
          {analysis?.target_request?.score == 0 && (
            <>
              {t(
                "The-target-request-does-not-appear-in-the-150-first-words-of-your-content!-Add-it!",
                "The target request does not appear in the 150 first words of your content! Add it!"
              )}
            </>
          )}
          {analysis?.target_request?.score == -1 && (
            <>{t("Please-add-content", "Please add content")}</>
          )}
        </p>
      </div>

      {/* Presence of intro and conclusion */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t(
            "Presence-of-introduction-and-conclusion",
            "Presence of introduction and conclusion"
          )}{" "}
        </p>
        <p
          className={`${
            analysis?.intro_presence?.score == 100
              ? "text-green-500"
              : analysis?.intro_presence?.score == 0 ||
                analysis?.intro_presence?.score == 20
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.intro_presence?.score == 100 && (
            <>
              {t(
                "Your-content-contains-both-an-introduction-and-a-conclusion",
                "Your content contains both an introduction and a conclusion."
              )}
            </>
          )}
          {analysis?.intro_presence?.score == 20 && (
            <>
              {`${
                analysis?.intro_presence.introLength == 0
                  ? t(
                      "the-introduction-is-missing",
                      "The introduction is missing."
                    )
                  : t("the-conclusion-is-missing", "The conclusion is missing.")
              }`}
            </>
          )}
          {analysis?.intro_presence?.score == 0 && (
            <>
              {t(
                "The-introduction-and-the-conclusion-are-missing",
                "The introduction and the conclusion are missing."
              )}
            </>
          )}{" "}
          {analysis?.intro_presence?.score == -1 && (
            <>{t("Please-add-content", "Please add content")}</>
          )}
        </p>
      </div>

      {/* Paragraph Density */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Paragraph-Density", "Paragraph Density")}{" "}
        </p>

        <p
          className={`${
            analysis?.paragraph_density?.score == 100
              ? "text-green-500"
              : analysis?.paragraph_density?.score === 50
              ? "text-yellow-400"
              : analysis?.paragraph_density?.score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.paragraph_density?.score == 100 && (
            <>
              {`${t(
                "A-good-amount-of-your-paragraphs",
                "A good amount of your paragraphs"
              )}  (${100 - analysis?.paragraph_density.percentage}%) 
                                 ${t(
                                   "have-a-recommended-size-(less-than-6-sentences)",
                                   "have a recommended size (less than 6 sentences)"
                                 )}.`}
            </>
          )}{" "}
          {analysis?.paragraph_density?.score == 50 && (
            <>
              {`${t(
                "Too-many-of-your-paragraphs",
                "Too many of your paragraphs"
              )}  (${analysis?.paragraph_density.percentage}%) 
                                  ${t(
                                    "are-too-long-(more-than-6-sentences)",
                                    "are too long (more than 6 sentences)"
                                  )}.`}
            </>
          )}{" "}
          {analysis?.paragraph_density?.score == 0 && (
            <>
              {`${
                ("More-than-half-of-your-paragraphs",
                "More than half of your paragraphs")
              } (${analysis?.paragraph_density.percentage}%) 
                                  ${t(
                                    "are-too-long-(more-than-6-sentences)",
                                    "are too long (more than 6 sentences)"
                                  )}.`}
            </>
          )}
          {analysis?.paragraph_density?.score == -1 && (
            <>{t("Please-add-content", "Please add content")}</>
          )}
        </p>
      </div>

      {/* Section Length Balance */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Section-length-balance", "Section length balance ")}{" "}
        </p>
        <p
          className={`${
            analysis?.length_balance?.score == 100
              ? "text-green-500"
              : analysis?.length_balance?.score === 50
              ? "text-yellow-400"
              : analysis?.length_balance?.score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.length_balance?.score == 100 && (
            <>
              {`${t(
                "A-good-number-of-sections-have-a-good-length",
                "A good number of sections have a good length"
              )}(${analysis?.length_balance.validParts}%).`}
            </>
          )}{" "}
          {analysis?.length_balance?.score == 50 && (
            <>
              {analysis?.length_balance.tooLong != 0 &&
                analysis?.length_balance.tooShort != 0 && (
                  <>
                    {`${t(
                      "Some-of-your-sections-are-longer-or-shorter-than-advised",
                      "Some of your sections are longer or shorter than advised"
                    )} 
                                      (${
                                        analysis?.length_balance.tooLong >
                                        analysis?.length_balance.tooShort
                                          ? analysis?.length_balance.tooLong
                                          : analysis?.length_balance.tooShort
                                      }%)`}
                  </>
                )}
              {analysis?.length_balance.tooLong != 0 &&
                analysis?.length_balance.tooShort == 0 && (
                  <>
                    {`${t("You-have", "You have")} ${
                      analysis?.length_balance.tooLong
                    }% ${t(
                      "sections-that-are-too-long",
                      "sections that are too long"
                    )}.`}
                  </>
                )}
              {analysis?.length_balance.tooLong == 0 &&
                analysis?.length_balance.tooShort != 0 && (
                  <>
                    {`${t("You-have", "You have")} ${
                      analysis?.length_balance.tooShort
                    }% ${t(
                      "sections-that-are-too-short",
                      "sections that are too short"
                    )}.`}
                  </>
                )}
            </>
          )}{" "}
          {analysis?.length_balance?.score == 0 && (
            <>
              {analysis?.length_balance.tooLong != 0 &&
                analysis?.length_balance.tooShort != 0 && (
                  <>
                    {`${t(
                      "Some-of-your-sections-are-longer-or-shorter-than-advised",
                      "Some of your sections are longer or shorter than advised"
                    )} 
                                      (${
                                        analysis?.length_balance.tooLong >
                                        analysis?.length_balance.tooShort
                                          ? analysis?.length_balance.tooLong
                                          : analysis?.length_balance.tooShort
                                      }%)`}
                  </>
                )}
              {analysis?.length_balance.tooLong != 0 &&
                analysis?.length_balance.tooShort == 0 && (
                  <>
                    {`${t("You-have", "You have")} ${
                      analysis?.length_balance.tooLong
                    }% ${t(
                      "sections-that-are-too-long",
                      "sections that are too long"
                    )}.`}
                  </>
                )}
              {analysis?.length_balance.tooLong == 0 &&
                analysis?.length_balance.tooShort != 0 && (
                  <>
                    {`${t("You-have", "You have")} ${
                      analysis?.length_balance.tooShort
                    }% ${t(
                      "sections-that-are-too-short",
                      "sections that are too short"
                    )}.`}
                  </>
                )}
            </>
          )}
          {analysis?.length_balance?.score == -1 && (
            <>{t("Please-add-content", "Please add content")}</>
          )}
        </p>
      </div>
    </>
  );
};
